import React, { useCallback, useEffect, useState } from 'react'
import PageHeaderLight from '../../../components/shared/PageHeaderLight';
import ProfileInformationLinear from '../../../components/shared/ProfileInformationLinear';
import WidgetAddDocument from '../../../components/widgets/WidgetAddDocument';
import WidgetNewContest from '../../../components/widgets/WidgetNewContest';
import UserTalents from '../../../components/UserTalents';
import WidgetUpdateProfile from '../../../components/widgets/WidgetUpdateProfile';
import DashboardHeaderProfileWidget from '../../../components/widgets/DashboardHeaderProfileWidget';
import { useStateValue } from '../../../StateProvider';
import { getDefaultValue, logout } from '../../../utils';
import { loadProfile, loadUserTalents, getCachedProfile, setCachedProfile } from '../../../utils/Network';
import { Redirect } from 'react-router-dom';

import DashboardAside from './DashboardAside';
import '../../Dashboard.css';


export default function Dashboard() {

    const [profile, setProfile] = useState(() => getCachedProfile());
    /** null = still loading; hide welcome until known, so users with a talent never see a flash. */
    const [hasUserTalent, setHasUserTalent] = useState(null);
    const [videosRefreshVersion, setVideosRefreshVersion] = useState(0);
    const [contestBannerRefreshVersion, setContestBannerRefreshVersion] = useState(0);

    const bumpMyVideos = useCallback(() => {
        setVideosRefreshVersion((v) => v + 1);
    }, []);

    const bumpContestBanner = useCallback(() => {
        setContestBannerRefreshVersion((v) => v + 1);
    }, []);

    const [{ translations }] = useStateValue();
    const translate = (str) => {
        if (!translations) return str;
        var translate = translations.find((x) => x.key == str);

        if (translate) return getDefaultValue(translate);
        else return "#" + str;
    };

    useEffect(() => {
        let cancelled = false;
        loadProfile().then((data) => {
            if (cancelled) return;
            if (data) {
                setProfile(data);
                setCachedProfile(data);
            } else {
                logout();
                window.location.href = "signin";
            }
        });
        if (getCachedProfile()?.role === "referee") {
            return () => {
                cancelled = true;
            };
        }
        loadUserTalents({ size: 1 })
            .then((talentsData) => {
                if (cancelled) return;
                const list = Array.isArray(talentsData)
                    ? talentsData
                    : talentsData?.results;
                setHasUserTalent(Array.isArray(list) && list.length > 0);
            })
            .catch(() => {
                if (!cancelled) setHasUserTalent(false);
            });
        return () => {
            cancelled = true;
        };
    }, []);

    if (profile?.role === "referee") {
        return <Redirect to="/referee/dashboard" />;
    }

    return (
        <div className="participant-dashboard">
            <div role="main" className="main page-background">
                <PageHeaderLight />
                <div className="container participant-dashboard__container pt-3 pb-5">

                    <div className="row pt-2  align-items-start participant-dashboard__row">
                        <div className="col-lg-9 participant-dashboard__main">
                            <header className="participant-dashboard__header">
                                <div className="participant-dashboard__header-inner">
                                    <DashboardHeaderProfileWidget
                                        profile={profile}
                                        onProfileUpdated={(p) => {
                                            setProfile(p);
                                            setCachedProfile(p);
                                        }}
                                    />
                                </div>
                            </header>
                            {hasUserTalent === false && (
                                <div className="participant-dashboard__header-copy lan-text-right">
                                    <p className="participant-dashboard__subtitle mb-0">{translate("Welcome to KurdishTalent dashboard. you can upload your videos and documents here.")}</p>
                                </div>
                            )}
                            <WidgetNewContest refreshVersion={contestBannerRefreshVersion} />
                            <section className="participant-dashboard__videos" aria-label="My videos">
                                <UserTalents
                                    reloadKey={videosRefreshVersion}
                                    onVideosChanged={bumpMyVideos}
                                />
                            </section>
                            <div className="widgets participant-dashboard__actions">
                                <WidgetAddDocument
                                    onVideosChanged={bumpMyVideos}
                                    onContestParticipationChange={bumpContestBanner}
                                />
                                <WidgetUpdateProfile />
                            </div>
                        </div>
                        {/* <ProfileInformationLinear className="participant-dashboard__mobile-profile" /> */}
                        <DashboardAside />
                    </div>

                </div>

            </div>

        </div>
    )

}
